import { ANALYTICS_EVENTS } from '@syncanix/shared';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { track } from '@/analytics/track';
import { getComparison } from '@/features/comparisons';

import { NotFound } from '../not-found';
import { ComparisonPage } from './ComparisonPage';

import type { ReactElement } from 'react';

/**
 * AF-136 — `/vs/:rival` route wrapper. Resolves the `:rival` param to a
 * comparison; an unknown slug renders the 404 page (no silent fallback). The
 * head (title + SEO meta) is owned by the rendered child: `ComparisonPage` for
 * a resolved rival, `NotFound` for the 404 branch.
 */
export function VsPage(): ReactElement {
  const { rival } = useParams<{ rival: string }>();
  const data = rival !== undefined ? getComparison(rival) : undefined;

  // "Which competitors do prospects compare us against?" — fire once a known
  // rival resolves (the 404 branch is not a comparison view).
  useEffect(() => {
    if (data !== undefined && rival !== undefined) {
      track(ANALYTICS_EVENTS.MARKETING_COMPARISON_VIEWED, { rival });
    }
  }, [data, rival]);

  if (data === undefined) {
    return <NotFound />;
  }
  return <ComparisonPage data={data} />;
}
